import WarningGram from './WarningGram';

export default WarningGram;
